import React, { useEffect, useState } from 'react';
import "./ProductInformation.styles.css";

const ProductInformation = ({ productDetail }) => {
  const [productDetails, setProductDetails] = useState(null);

  useEffect(async () => {
    setProductDetails(productDetail);
  }, [productDetail])

  return (
    <div className="std">
      {
        productDetails!=null && productDetails.specs!=null?
        <>
        {
        productDetails.specs.map((product,i) => (
          <>
          <p>
            <strong>{product.specname}</strong>
          </p>
          <span>
            {product.description}
          </span>
          <hr />
          </>
        ))}
        </>:<>
        {/* <p>
        <strong>FEATURES</strong>
      </p>
      <ul>
        <li>
          PureDirect technology distributes air more comfortably and effectively
        </li>
        <li>
          This proprietary technology uses two airflow streams, distributing air
          further and more evenly throughout your room
        </li>
        <li>
          360 degree DuPont HEPA filter captures pollutants and VOC gases/odors
          from all directions. UV-C light kills germs and bacteria that can get
          trapped in the filter
        </li>
        <li>
          Simple touch-button control of fan speed, UV mode, and filter
          replacement indicators
        </li>
        <li>Contemporary design that complements any home environment</li>
        <li>Portability is easy with the sleek, integrated handle</li>
      </ul>
      <hr />
      <p>
        <strong>KEY INFORMATION</strong>
      </p>
      <span>Pack Size : Qty</span>
      <span>Carton Size: Qty</span>
      <span>Product Dimension:</span>
      <hr />
      <p>
        <strong>COUNTRY OF ORIGIN</strong>
      </p>
      <span>{productDetail?.productInformation?.countryOrigin || "Made in Germany"}</span>
      <hr />
      <p>
        <strong>PREPARATION</strong>
      </p>
      <span>
        {productDetail?.productInformation?.preparation || "This proprietary technology uses two airflow streams, distributing air further and more evenly throughout your room"}
      </span>
      <hr />
      <p>
        <strong>INGREDIENT</strong>
      </p>
      <span>{productDetail?.productInformation?.ingredient || "Lorem ipsum"}</span>
      <hr />
      <p>
        <strong>{productDetail?.productInformation?.nutritionInfo || "NUTRITION INFO"}</strong>
      </p>
      <span>Lorem ipsum</span>
      <hr />
      <p>
        <strong>STORAGE</strong>
      </p>
      <span>{productDetail?.productInformation?.storage || "Room Temperature"}</span>
      <span>xC to xC</span>
      <hr />
      <p>
        <strong>DIETARY</strong>
      </p>
      <span>Vegan</span>
      <span>Halal</span>
      <span>Healthier choice</span>
      <br />
      <br /> */}
        </>
      }
      
    </div>
  );
};

export default ProductInformation;
